import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Avatar from './avatar.gjs';
import Component from '@glimmer/component';
import styles from './contact-list-item.module.scss';

export default class ContactListItem extends Component {
  @service messaging;
  @service messagingNavigation;

  get isReadOnly() {
    return this.args.readOnly === true;
  }

  get role() {
    return this.isReadOnly ? undefined : 'button';
  }

  get tabindex() {
    return this.isReadOnly ? -1 : 0;
  }

  get userNames() {
    return this.args.contact.members.map(user => user.name).join(' & ');
  }

  get isCoupleContact() {
    return this.args.contact.members?.length === 2;
  }

  @action
  handleClick() {
    if (this.isReadOnly) {
      return;
    }
    this.openConversationWithContacts();
  }

  @action
  async openConversationWithContacts() {
    const conversation = this.messaging.findOrCreateConversationWithContacts(
      this.args.contact.members
    );
    this.messagingNavigation.toConversation(conversation);
  }

  <template>
    <li
      class="{{styles.component}} contact-list-item {{if this.isReadOnly 'read-only'}}"
      data-test-contact={{@contact.id}}
      data-test-contact-list-item
      role={{this.role}}
      tabindex={{this.tabindex}}
      aria-label={{unless
        this.isReadOnly
        (t "emc.contact_list_item.select_aria_label" userNames=this.userNames)
      }}
      {{on "click" this.handleClick}}
      {{! Using variable to determine tabindex causes false positive in template-lint }}
      {{! template-lint-disable no-positive-tabindex }}
    >
      <Avatar @users={{@contact.members}} @isCouple={{this.isCoupleContact}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{this.userNames}}</span>
        </div>
      </div>
    </li>
  </template>
}
